export { VALIDATION_MESSAGE_MAPPER } from './src/validation-messages/validation-messages-mapper-token';
export { FormValidators } from './src/validators/form-validators';
export { ValidationMessagesComponent } from './src/validation-messages/validation-messages.component';
export { ValidationMessagesModule } from './src/validation-messages/validation-messages.module';
export { ValidationMessageMap } from './src/validation-messages/validation-messages-map';
export { ValidationMessageMapperFn } from './src/validation-messages/validation-messages-map-fn';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
